import { render, staticRenderFns } from "./FiltersConstructor.vue?vue&type=template&id=49368876"
import script from "./FiltersConstructor.vue?vue&type=script&lang=js"
export * from "./FiltersConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49368876')) {
      api.createRecord('49368876', component.options)
    } else {
      api.reload('49368876', component.options)
    }
    module.hot.accept("./FiltersConstructor.vue?vue&type=template&id=49368876", function () {
      api.rerender('49368876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters-constructor/FiltersConstructor.vue"
export default component.exports